import GroupingLocationList from './GroupingLocationList';

export default GroupingLocationList;
